export default __webpack_public_path__ + "static/media/m.fd403cab.svg";